import { rolesID } from './rolesID';

export const IMAGE_ACCEPT = 'image/*,image/jpeg,image/apng,image/heic';

// TODO: удалить когда появятся на бэке эндпоинты
export const ROLE_OPTIONS = [
  {
    label: 'Администратор',
    id: 'admin'
  },
  {
    label: 'Контент-менеджер',
    id: 'content-menager'
  },
  {
    label: 'Бонус-менеджер',
    id: 'bonus-menager'
  },
  {
    label: 'Менеджер ТП',
    id: 'menager-tp'
  }
];

export const STATUS_OPTIONS = [
  {
    label: 'Приглашен',
    value: 'Приглашен'
  },
  {
    label: 'Активен',
    value: 'Активен'
  },
  {
    label: 'Заблокирован',
    value: 'Заблокирован'
  }
];

export const APPLICATION_STATUS_OPTIONS = [
  {
    label: 'Все',
    value: 'all'
  },
  {
    label: 'Новая',
    value: 'new',
  },
  {
    label: 'Исполнена',
    value: 'executed',
  },
  {
    label: 'Отклонена',
    value: 'rejected',
  },
  {
    label: 'В обработке',
    value: 'in_processing',
  }
];
export const APPLICATION_SORT_OPTIONS = [
  {
    label: 'Номеру заявки',
    value: 'request_num'
  },
  {
    label: 'Дате создания',
    value: 'created_at'
  },
  {
    label: 'SLA',
    value: 'sla'
  }
];

export const DEPARTMENT_OPTIONS = [
  {
    label: 'Департамент 1',
    value: 'department1'
  },
  {
    label: 'Департамент 2',
    value: 'department2'
  }
];

export const APPLICATION_STATUS = {
  new: { label: 'Новая', status: 'new', color: 'primary.main' },
  executed: { label: 'Исполнена', status: 'executed', color: 'success.main' },
  rejected: { label: 'Отклонена', status: 'rejected', color: 'error.main' },
  in_processing: { label: 'В обработке', status: 'in_processing', color: 'warning.main' }
};

export const SEARCH_CUSTOMER_BY = [
  {
    value: 'INN',
    label: 'ИИН'
  },
  {
    value: 'numberPhone',
    label: 'Номер мобильного телефона'
  },
  {
    value: 'localID',
    label: 'Лицевой счет'
  }
];

export const TYPE_CUSTOMER_BY_PHONE = [
  {
    value: 1,
    label: 'Физическое лицо'
  },
  {
    value: 2,
    label: 'Организация'
  },
  {
    value: 3,
    label: 'Индивидуальный предприниматель'
  }
];

export const TYPE_CUSTOMER_BY_LC = [
  { value: 1, label: 'Астана' },
  { value: 2, label: 'Караганда' },
  { value: 3, label: 'Актобе' },
  { value: 4, label: 'Атырау' },
  { value: 5, label: 'Павлодар' },
  { value: 6, label: 'Шымкент' },
  { value: 8, label: 'Костанай' },
  { value: 9, label: 'Петропавловск' },
  { value: 10, label: ' Кокшетау' },
  { value: 11, label: ' Актау' },
  { value: 12, label: ' Усть-Каменогорск' },
  { value: 13, label: ' Уральск' },
  { value: 14, label: ' Тараз' },
  { value: 15, label: ' Кызылорда' },
  { value: 16, label: ' Талдыкорган' },
  { value: 17, label: ' Алматы' },
  { value: 18, label: 'Семей' }
];

export const REASON_FOR_CHARGE_ID = [
  {
    label: 'Оспаривание начислений',
    value: 1
  },
  {
    label: 'Технические неполадки (1 степень)',
    value: 2
  },
  {
    label: 'Технические неполадки (2 степень)',
    value: 3
  },
  {
    label: 'Технические неполадки (3 степень)',
    value: 4
  },
  {
    label: 'Недоволен качеством установки',
    value: 5
  },
  {
    label: 'Долгое ожидание монтажа/демонтажа',
    value: 6
  },
  {
    label: 'Претензия к обслуживанию',
    value: 7
  }
];

export const SUBSCRIBER_STATUS = [
  { label: 'Лоялен', value: 'loyal' },
  { label: 'Нейтрален', value: 'neutral' },
  { label: 'Негативен', value: 'negative' }
];

export const BONUSES_STATUS = [
  { label: 'Все', value: 'all' },
  { label: 'Создана', value: 'created' },
  { label: 'Активна', value: 'active' },
  { label: 'Архив', value: 'archive' },
  { label: 'Одобрена', value: 'approved' },
  { label: 'На одобрении', value: 'on_approve' },
  { label: 'Доработка', value: 'rework' }
];

export const BONUSE_PACKAGES_STATUS = [
  { label: 'Все', value: 'all' },
  { label: 'Создана', value: 'created' },
  { label: 'Активна', value: 'active' },
  { label: 'Архив', value: 'archive' },
];

export const PROMOTIONS_STATUS = [
  { label: 'Все', value: 'all' },
  { label: 'Создана', value: 'created' },
  { label: 'Активна', value: 'active' },
  { label: 'Архив', value: 'archive' }
];

export const DISABLED_CONTROL_TOOLTIP = 'У вас нет прав доступа к данному функционалу';

export const MAILING_TYPE = {
  SMS: 'СМС',
  EMAIL: 'Email',
  // PUSH: 'Push',
};

export const PERMISSIONS = {
  BONUS: {
    value: 'bonus',
    RetrieveBonusCards: { label: 'Просмотр карточки событий по начислению бонуса', value: 'retrieve_bonus_cards', id: 154 },
    UpdateBonusCards: { label: 'Редактировать карточку событий по начислению бонуса', value: 'update_bonus_cards', id: 168 },
    CreateBonusCards: { label: 'Создание кампаний', value: 'create_bonus_cards', id: 111 },
    ListBonusCards: { label: 'Просмотреть список событий по начислению бонусов', value: 'list_bonus_cards', id: 133 },
    ArchiveBonusCards: { label: 'Архивировать карточку событий', value: 'archive_bonus_cards', id: 208 },
    FilterBonusCards: { label: 'Фильтровать список событий по начислению бонусов', value: 'filter_bonus_cards', id: 188 },
    SearchBonusCards: { label: 'Поиск карточки события по начислению бонусов', value: 'search_bonus_cards', id: 198 },
    CopyBonusCards: { label: 'Копировать карточку событий', value: 'copy_bonus_card', id: 218 },
    ListBonusTriggers: { label: 'Список триггеров по начислению бонусов абонента', value: 'list_bonus_triggers', id: 219 },
    CreateCampaign: { label: 'Создать бонусную кампанию', value: 'create_bonus_company', id: 121 },
    DeleteCampaign: { label: 'Удалить бонусную кампанию', value: 'delete_bonus_company', id: 182 },
    CreateService: { label: 'Создать акцию кампании по начислению бонусов', value: 'create_bonus_company_services', id: 117 },
    DeleteService: { label: 'Удалить акцию кампании по начислению бонусов', value: 'delete_bonus_company_services', id: 180 },
    ApproveOrReject: { label: 'Одобрение или отклонение запускаемой кампании', value: 'update_status_bonus_card', id: 809 }
  },
  SUPPORT: {
    CreateSupportBonusRequests: { label: 'Создание Заявки на начисление бонусов', value: 'create_support_bonus_requests', id: 115 },
    ListSupportBonusRequests: { label: 'Просмотр списка заявок на начисление бонусов', value: 'list_support_bonus_requests', id: 135 },
    ListSupportBonusRequestsByManager: { label: "Просмотр списка заявок на начисление бонусов в разделе 'Мои заявки'", value: 'list_support_bonus_requests_by_manager', id: 222 },
    RetrieveSupportBonusRequests: { label: 'Просмотреть заявки на начисление бонусов', value: 'retrieve_support_bonus_requests', id: 156 },
    SearchSupportBonusRequests: { label: 'Поиск из Мои заявки', value: 'search_support_bonus_requests', id: 199 },
    FilterSupportBonusRequests: { label: 'Фильтровать из Мои заявки', value: 'filter_support_bonus_requests', id: 189 },
    UpdateSupportBonusRequests: { label: 'Обработать заявку из Мои заявки', value: 'update_support_bonus_requests', id: 169 },
    RetrieveCustomer: { label: 'Поиск абонентов', value: 'retrieve_customer', id: 167 },
    ExportCustomersList: { label: 'Выгрузка списка абонентов по дате', value: 'export_customers_by_date', id: 213 },
    value: 'support'
  },
  LOGGING: {
    ListHistory: { label: 'Просмотреть историю событий', value: 'list_history', id: 140 },
    value: 'history',
  },
  USER: {
    RetrieveUsers: { label: 'Просмотреть карточку менеджера', value: 'retrieve_users', id: 153 },
    UpdateUsers: { label: 'Редактировать карточку менеджера', value: 'update_users', id: 112 },
    FilterUsers: { label: 'Фильтровать список менеджеров', value: 'filter_users', id: 159 },
    ListUsers: { label: 'Просмотреть список менеджеров', value: 'list_users', id: 161 },
    SearchUsers: { label: 'Поиск менеджера', value: 'search_users', id: 157 },
    CreateUsers: { label: 'Пригласить менеджера в компанию', value: 'invite_users', id: 118 },
    ActivateUsers: { label: 'Разблокировать карточку менеджера', value: 'activate_users', id: 114 },
    DeactivateUsers: { label: 'Заблокировать карточку менеджера', value: 'deactivate_users', id: 155 },
    UpdateUserRoles: { label: 'Изменение роли менеджера', value: 'update_user_roles', id: 130 },
    InviteUsers: { label: 'Пригласить менеджера в компанию', value: 'invite_users', id: 118 },
    value: 'user',
  },
  UNDEFINED: {
    ResetPassword: { label: 'Сбросить пароль', value: 'reset_password', id: 143 },
    UploadAvatar: { label: 'Загрузить аватар менеджера', value: 'upload_avatar' },
    UpdatePermissions: { label: 'Изменение пермишенов роли', value: 'update_permissions', id: 221 },
    SearchCustomer: { label: '', value: 'search_customer', id: 207 },
    value: 'undefined',
  },
  MAILING: {
    ListBonusesMailingTemplates: { label: 'Список шаблонов рассылки в бонусной карточке', value: 'list_bonuses_mailing_templates', id: 231 },
    UpdateMailingTemplates: { label: 'Изменить шаблон рассылки на статусе “Создано”', value: 'update_mailing_templates', id: 230 },
    CreateBonusesMailingTemplates: { label: 'Добавить шаблон рассылки в карточку по начислению бонусов', value: 'create_bonuses_mailing_templates', id: 238 },
    ListMailingTimeBounds: { label: 'Список периодов отправки рассылки', value: 'list_mailing_time_bounds', id: 244 },
    FilterMailingTemplates: { label: 'Фильтрация шаблонов рассылки', value: 'filter_mailing_templates', id: 233 },
    DeleteBonusesMailingTemplates: { label: 'Удаление шаблона рассылки из бонусной карточки', value: 'delete_bonuses_mailing_templates', id: 243 },
    RetrieveMailingTemplates: { label: 'Просмотреть карточку шаблона', value: 'retrieve_mailing_templates', id: 236 },
    SearchMailingTemplates: { label: 'Поиск шаблона рассылки', value: 'search_mailing_templates', id: 225 },
    // UpdateBonusesMailingTemplates: { label: 'Изменение шаблона рассылки в бонусной карточке', value: 'update_bonuses_mailing_templates', id: 223 },
    DeleteMailingTemplates: { label: 'Удалить шаблон рассылки на статусе “Архив”', value: 'delete_mailing_templates', id: 251 },
    ArchiveMailingTemplates: { label: 'Архивировать / Вернуть в работу шаблон рассылки', value: 'archive_mailing_templates', id: 245 },
    CreateMailingTemplates: { label: 'Создать шаблон рассылки', value: 'create_mailing_templates', id: 242 },
    ListMailingTemplates: { label: 'Просмотреть список шаблонов рассылки', value: 'list_mailing_templates', id: 239 },
    UploadCustomerMailing: { label: 'Выгрузка списков абонентов по рассылкам в статусах отличных от “Создано”', value: 'upload_customer_mailing', id: 273 },
    DeleteBonusCardCreatedMailingTemplates: { label: 'Удалить рассылку к событию на статусе “Создано”', value: 'delete_bonus_card_created_mailing_templates', id: 302 },
    DeleteBonusCardActiveMailingTemplates: { label: 'Удалить рассылку к событию на статусе “Активно”', value: 'delete_bonus_card_active_mailing_templates', id: 304 },
    CreateBonusCardCreatedMailingTemplates: { label: 'Добавить рассылку к событию на статусе “Создано”', value: 'create_bonus_card_created_mailing_templates', id: 303 },
    CreateBonusCardActiveMailingTemplates: { label: 'Добавить рассылку к событию на статусе “Активно”', value: 'create_bonus_card_active_mailing_templates', id: 305 },
    value: 'mailing',
  },
  HISTORY: {
    ListHistory: { label: 'Просмотреть историю событий ', value: 'list_history', id: 140 },
    value: 'history',
  },
  DEDUCTION: {
    value: 'deduction',
    name: 'Учет бонусов',
    RetrieveDeductionBonusTransactions: { label: 'Просмотр детальной информации по транзакции учета бонуса', value: 'retrieve_deduction_bonus_transactions', id: 306 },
    ListDeductionBonusTransactions: { label: 'Просмотр списка транзакций по учету бонусов', value: 'list_deduction_bonus_transactions', id: 301 },
    DownloadBonusTransactionXML: { label: 'Просмотреть XML', value: 'download_bonus_transaction_xml', id: 209 },
  },
  PARTNERS: {
    value: 'partners',
    name: 'Партнеры',
    createPartners: { id: 364, label: 'Создать карточку партнера', value: 'create_partners' },
    archivePartners: { id: 376, label: 'Архивировать карточку партнера', value: 'update_partners_status' },
    listPartners: { id: 325, label: 'Просмотреть список партнеров', value: 'list_partners' },
    retrievePartners: { id: 375, label: 'Просмотр карточки партнера', value: 'retrieve_partners' },
    updatePartners: { id: 377, label: 'Редактировать карточку партнера', value: 'update_partners' }
  },
  PARTNER: {
    value: 'partner',
    name: 'Партнерские акции',
    listPartnerPromotions: { id: 411, label: 'Просмотреть список акций', value: 'list_partner_promotions' },
    retrievePartnerPromotions: { id: 409, label: 'Просмотр карточки акции', value: 'retrieve_partner_promotions' },
    updatePartnerPromotions: { id: 398, label: 'Редактировать карточку акции', value: 'update_partner_promotions' },
    copyPartnerPromotions: { id: 457, label: 'Копирование карточки акции', value: 'copy_partner_promotions' },
    archivePartnerPromotions: { id: 400, label: 'Архивировать карточку акции', value: 'archive_partner_promotions' },
    createPartnerPromotions: { id: 417, label: 'Создать карточку акции', value: 'create_partner_promotions' }
  }
}

export const BASE_PERMISSION_ROLES = [
  rolesID.ROLE_ADMINISTRATOR,
  rolesID.ROLE_MANAGER_SUPPORT,
  rolesID.ROLE_SUPERVISER_TP,
  rolesID.ROLE_BONUS_MANAGER,
  rolesID.ROLE_CONTENT_MANAGER,
];
